import React from 'react';
import { useNavigate } from 'react-router-dom';
import journalingImg from '../../assets/journaling-image.jpg';
// Reuse the same gradient/hero styles as Daily Reflection
import '../DailyReflection/style.css';

export default function TrainMindCard() {
  const navigate = useNavigate();

  return (
    <div className="journal-entry reflection-card-wrapper">
      <div
        className="reflection-card"
        style={{
          backgroundImage: `url(${journalingImg})`
        }}
      >
        <div className="reflection-card-content">
          <h3>Train Your Mind</h3>
          <p>
            Clear mind. Strong habits. Better results. Journaling keeps you on track.
          </p>
          <button className="reflection-btn" onClick={() => navigate('/train-mind')}>Explore</button>
        </div>
      </div>
    </div>
  );
}

